module.exports = {"id":"212476","name":"Medrán","rating":"75","photo":"./data/images/photos/1/212476.png","club":{"name":"Deport. Alavés","logo":"./data/images/clubs/Deport.Alaves.png"},"positions":["MC","MDC","MOC"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/Medran0.json
// module id = 2964
// module chunks = 0